import React from "react";
import Select from "react-select";
import { colourOptions } from "./data";


// Custom components and styles
const CustomClearText = () => "clear all";
const ClearIndicator = (props) => {
   const {
      children = <CustomClearText />,
      getStyles,
      innerProps: { ref, ...restInnerProps },
   } = props;
   return (
      <div
         {...restInnerProps}
         ref={ref}
         style={getStyles("clearIndicator", props)}
      >
         <div style={{ padding: "0px 5px" }}>{children}</div>
      </div>
   );
};

const ClearIndicatorStyles = (base, state) => ({
   ...base,
   cursor: "pointer",
   color: state.isFocused ? "green" : "black",
});


const customStyles = {
  ClearIndicatorStyles: ClearIndicatorStyles,
   control: (base, state) => ({
     ...base,
     boxShadow: state.isFocused ? `0 0 0 1px #3b5220` : base.boxShadow, 
     borderColor: state.isFocused ? "#3b5220" : "#ffffff",
     borderBottom: "1px solid",
     transition: "all 0.3s ease", 
     fontSize: '1rem', // Set font size here
     '&:hover': {
       borderColor: '#3b5220',
       boxShadow: '0 0 0 1px #3b5220', 
     }
   }),
   
   // Option styling (hover, selected, and clicked)
   option: (base, state) => ({
     ...base,
     backgroundColor: state.isSelected
       ? '#cfe0bd' 
       : state.isFocused
       ? '#76a54159' 
       : base.backgroundColor,
     color: state.isSelected || state.isFocused ? '#3b5220' : base.color,
     cursor: 'pointer',
     transition: 'all 0.3s ease',
     '&:active': {
       backgroundColor: '#cfe0bd', 
     }
   }),
 
   singleValue: (base) => ({
     ...base,
     color: '#3b5220', 
   }),
 
   // Clear indicator styling (if necessary)
   clearIndicator: (base) => ({
     ...base,
     color: '#3b5220',
   }),

    // Indicator separator styling
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: '#ffffff', // Set the background color of the separator to white
    }),
 };
 
 export default function CustomClearIndicator() {
   return (
     <Select
       closeMenuOnSelect={false}
       components={{ ClearIndicator }}
       styles={customStyles}
       defaultValue={[colourOptions[4], colourOptions[5]]}
       isMulti
       options={colourOptions}
     />
   ); 
 }

